import { useEffect, useMemo, useState } from "react";

// material-ui
import { Box, Modal, Stack } from "@mui/material";

// project-imports

import MainCard from "components/MainCard";
import SimpleBar from "components/third-party/SimpleBar";
import { TranslationsModel } from "model/translations";
// types

import { RolesModel } from "model/roles";

import { useAppDispatch } from "hooks";
import FormPageManagmentTranslation from "./editTranslation";

interface Props {
  open: boolean;
  modalToggler: (state: boolean) => void;
  customer?: TranslationsModel | null;
  id: number;
  fetchData: any;
}

// ==============================|| CUSTOMER ADD / EDIT ||============================== //

const TranslationsModal = ({
  open,
  modalToggler,
  customer,
  id,
  fetchData,
}: Props) => {
  const closeModal = () => modalToggler(false);
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState<boolean>(false);

  const customerForm = useMemo(
    () => (
      <FormPageManagmentTranslation
        id={id}
        loading={loading}
        setLoading={setLoading}
        fetchData={fetchData}
        customer={customer || null}
        closeModal={closeModal}
      />
    ),

    // eslint-disable-next-line
    [customer]
  );
  return (
    <>
      {open && (
        <Modal
          open={open}
          onClose={closeModal}
          aria-labelledby="modal-customer-add-label"
          aria-describedby="modal-customer-add-description"
          sx={{
            "& .MuiPaper-root:focus": {
              outline: "none",
            },
          }}
        >
          <MainCard
            sx={{
              width: `calc(100% - 48px)`,
              minWidth: 340,
              maxWidth: 600,
              height: "auto",
              maxHeight: "calc(100vh - 48px)",
            }}
            modal
            content={false}
          >
            <SimpleBar
              sx={{
                maxHeight: `calc(100vh - 48px)`,
                "& .simplebar-content": {
                  display: "flex",
                  flexDirection: "column",
                },
              }}
            >
              {customerForm}
            </SimpleBar>
          </MainCard>
        </Modal>
      )}
    </>
  );
};

export default TranslationsModal;
